// When the user scrolls down 20px from the top of the document, slide down the navbar
// When the user scrolls to the top of the page, slide up the navbar (50px out of the top view)
$(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 20) {
        $(".utility-bar").addClass("sticky");
    } else {
        $(".utility-bar").removeClass("sticky");
    }
});